import type { ComponentType } from 'react'
import type { AgentOutputProps } from './types'
import JsonRenderer from './renderers/JsonRenderer'
import VideoRenderer from './renderers/VideoRenderer'
import ArgusSessionRenderer from './renderers/ArgusSessionRenderer'
import PdfRenderer from './renderers/PdfRenderer'
import ImageRenderer from './renderers/ImageRenderer'
import OfficeFileRenderer from './renderers/OfficeFileRenderer'
import ActionItemsRenderer from './renderers/ActionItemsRenderer'
import OrchestrationDAGRenderer from './renderers/OrchestrationDAGRenderer'
import TranscriptRenderer from './renderers/TranscriptRenderer'
import MeetingTranscriptRenderer from './renderers/MeetingTranscriptRenderer'
import QAReportRenderer from './renderers/QAReportRenderer'
import DiffRenderer from './renderers/DiffRenderer'
import CodeRenderer from './renderers/CodeRenderer'
import DocumentDiffRenderer from './renderers/DocumentDiffRenderer'
import N8nWorkflowRenderer from './renderers/N8nWorkflowRenderer'

/**
 * Registry mapping agent output_kind → renderer component.
 *
 * output_kind strings come from backend/agents/agent_docs.py::AGENT_OUTPUT_KINDS
 * and are surfaced via GET /api/v1/agents/centralized/{name}/docs.
 *
 * Unlisted kinds fall through to JsonRenderer via pickRenderer().
 */
export const RENDERERS: Record<string, ComponentType<AgentOutputProps>> = {
  // Core
  'json': JsonRenderer,
  // Media
  'video': VideoRenderer,
  'argus-session': ArgusSessionRenderer,
  'image': ImageRenderer,
  'chart-image': ImageRenderer,
  'image-gallery': ImageRenderer,
  // Documents
  'pdf': PdfRenderer,
  'office-file': OfficeFileRenderer,
  // Meetings
  'action-items': ActionItemsRenderer,
  'transcript': TranscriptRenderer,
  'meeting-transcript': MeetingTranscriptRenderer,
  // Workflows
  'orchestration-dag': OrchestrationDAGRenderer,
  'n8n-workflow': N8nWorkflowRenderer,
  // Code + diffs
  'qa-report': QAReportRenderer,
  'diff': DiffRenderer,
  'code': CodeRenderer,
  'document-diff': DocumentDiffRenderer,
}

export function pickRenderer(
  outputKind: string | null | undefined,
): ComponentType<AgentOutputProps> {
  if (!outputKind) return RENDERERS['json']
  return RENDERERS[outputKind] ?? RENDERERS['json']
}
